import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";

const iconSx = { fontSize: 20, color: "rgba(200,184,122,0.5)" };
const emailIconSx = { fontSize: 26, color: "rgba(200,184,122,0.5)" };
const pinIconSx = { fontSize: 20, color: "#c8b87a" };

const contacts = [
  {
    icon: <EmailOutlinedIcon sx={emailIconSx} />,
    label: "Email",
    content: (
      <Typography
        component="a"
        href="mailto:va.vitek@seznam.cz"
        sx={{ color: "#f5edd8", fontSize: "14px", textDecoration: "none", "&:hover": { color: "#c8b87a" }, wordBreak: "break-all" }}
      >
        va.vitek@seznam.cz
      </Typography>
    ),
  },
  {
    icon: <PhoneOutlinedIcon sx={iconSx} />,
    label: "Telefon",
    content: (
      <Typography
        component="a"
        href="tel:+420604795935"
        sx={{ color: "#f5edd8", fontSize: "14px", textDecoration: "none", "&:hover": { color: "#c8b87a" } }}
      >
        +420 604 795 935
      </Typography>
    ),
  },
  {
    icon: <PlaceOutlinedIcon sx={pinIconSx} />,
    label: "Adresa",
    content: (
      <Typography sx={{ color: "#f5edd8", fontSize: "14px", lineHeight: 1.7 }}>
        Lipí 64<br />547 01 Náchod
      </Typography>
    ),
  },
  {
    icon: <BadgeOutlinedIcon sx={iconSx} />,
    label: "IČO",
    content: (
      <Typography sx={{ color: "#f5edd8", fontSize: "14px" }}>
        04583949
      </Typography>
    ),
  },
];

const KontaktSection: React.FC = () => {
  return (
    <Box id="kontakt" component="footer" sx={{ background: "#2d2a22" }}>
    <Box sx={{ py: { xs: 6, md: 10 }, px: { xs: 2, md: 6 }, maxWidth: "950px", mx: "auto" }}>
      <Typography
        sx={{ fontSize: "13px", letterSpacing: "4px", color: "#7a6a45", textTransform: "uppercase", mb: 1 }}
      >
        Kontakt
      </Typography>
      <Typography variant="h4" component="h2" sx={{ color: "#f5edd8", fontWeight: 700, mb: 1 }}>
        Statek Vítek
      </Typography>
      <Typography sx={{ color: "#8a7a5a", mb: 5, fontSize: "15px" }}>
        Ozvěte se — rádi odpovíme na jakýkoli dotaz.
      </Typography>

      <Grid container spacing={3} sx={{ maxWidth: "860px" }}>
        {contacts.map((c) => (
          <Grid item xs={12} sm={6} md={3} key={c.label}>
            <Box
              sx={{
                p: 3,
                background: "#3a3628",
                borderRadius: "12px",
                border: "1px solid rgba(200,184,122,0.12)",
                height: "100%",
              }}
            >
              {/* Label row: icon + label inline */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                {c.icon}
                <Typography sx={{ color: "#8a7a5a", fontSize: "11px", letterSpacing: "2px", textTransform: "uppercase" }}>
                  {c.label}
                </Typography>
              </Box>
              {c.content}
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Footer line */}
      <Box sx={{ mt: 6, pt: 3, borderTop: "1px solid rgba(255,255,255,0.06)", maxWidth: "860px" }}>
        <Typography sx={{ color: "#4a4235", fontSize: "13px" }}>
          © Rodinný statek Vítek · Lipí u Náchoda
        </Typography>
      </Box>
    </Box>
    </Box>
  );
};

export default KontaktSection;
